import { createSlice } from "@reduxjs/toolkit";

interface SummaryReportInitialStateModel {
  filter:any;
}
const SummaryReportInitialState: SummaryReportInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:-1,
  

  }
};

const summaryReportSlice = createSlice({
  name: "SummaryReportSlice ",
  initialState: SummaryReportInitialState,
  reducers: {
    handleSetSummaryReportFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetSummaryReportFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:-1,
        
      };
    },
  },
});

export const {
  handleSetSummaryReportFilter,
  handleResetSummaryReportFitler,
} = summaryReportSlice.actions;
export default summaryReportSlice;
